/* unplugin-vue-components disabled */import { render } from "./loginDialog.vue?vue&type=template&id=b6b7ec36&scoped=true&ts=true"
import script from "./loginDialog.vue?vue&type=script&lang=ts"
export * from "./loginDialog.vue?vue&type=script&lang=ts"

import "./loginDialog.vue?vue&type=style&index=0&id=b6b7ec36&scoped=true&lang=css"
import "./loginDialog.vue?vue&type=style&index=1&id=b6b7ec36&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b7ec36"],['__file',"src/components/nav-aside/cpns/loginDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6b7ec36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6b7ec36', __exports__)) {
    console.log('reload')
    api.reload('b6b7ec36', __exports__)
  }
  
  module.hot.accept("./loginDialog.vue?vue&type=template&id=b6b7ec36&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('b6b7ec36', render)
  })

}


export default __exports__